/* eslint-disable no-console */
import { notification } from 'antd';
import { useState } from 'react';

type CopiedValue = string | null;
type CopyFn = (_text: string) => Promise<boolean>; // Return success

export function useCopyToClipboard(): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      notification.error({ message: 'Clipboard not supported' });
      return false;
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      notification.success({ message: 'Copy thành công' });
      return true;
    } catch (error) {
      notification.error({ message: 'Copy thất bại' });
      setCopiedText(null);
      return false;
    }
  };

  return [copiedText, copy];
}
